import { CellValue, Renderer } from 'react-table'

export function HtmlCellRenderer({ value }: CellValue): Renderer<CellValue> | null {
  if (!value?.value) return null

  // eslint-disable-next-line react/no-danger
  return <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: value.value }} />
}
